import { breakpoints, colors } from 'style'
import styled from 'styled-components'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const BookInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;

  .title-section {
    padding-top: 1rem;
  }

  .prompts-progress {
    display: flex;
    flex-direction: column;
    align-items: center;

    .prompts-bar-container {
      height: 50px;
      width: 100%;
      padding: 1rem 0;
    }

    .prompt-stats {
      display: flex;
      margin-top: 1rem;
      text-align: center;

      .prompt-state-label {
        border-bottom: 2px dashed ${colors.gray};
      }

      h2 {
        margin-bottom: 0;
      }
    }
  }

  .project-stats {
    background-color: ${colors.white};
    border-radius: 15px;
    padding: 1rem 2rem;
    margin: 0 1rem;

    .info-item {
      .stat-icon {
        display: none;
      }

      .stat-label {
        border-bottom: 2px dashed ${colors.gray};
      }

      .stat-count {
        margin-right: 1rem;
      }

      h4 {
        display: flex;
        justify-content: flex-start;
        text-align: center;
      }
    }

    @media (min-width: ${breakpoints.desktop}px) {
      display: flex;
      justify-content: center;
      gap: 1rem;
      background-color: unset;
      padding: 0;
      margin: 0 1rem;

      .info-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        max-width: 300px;
        background-color: ${colors.white};
        border-radius: 15px;
        padding: 1rem;
        margin-bottom: 1rem;

        .stat-icon {
          display: block;
          font-size: 36px;
          min-width: 36px;
          color: ${colors.dark7};
        }

        .stat-count {
          margin-right: 0;
        }

        h4 {
          flex-direction: column;
          align-items: center;
          .info-item {
            .stat-icon {
              font-size: 24px;
              min-width: 24px;
            }
            h4 {
              font-size: 16px;
            }
          }
        }
      }
    }

    @media (min-width: ${breakpoints.xl}px) {
      .info-item {
        flex-direction: row;
        .stat-icon {
          font-size: 36px;
          min-width: 36px;
          margin-right: 1rem;
        }

        .stat-count {
          margin-bottom: 2px;
        }

        .stat-label {
          margin-left: 5px;
        }

        h4 {
          flex-direction: row;
          font-size: 18px;
          margin-top: 2px;
          margin-bottom: 0;
        }
      }
    }
  }

  .icon-option {
    margin-right: 10px;
    float: left;
  }

  .things-to-do-action {
    cursor: pointer;
  }

  .things-to-do-action:hover {
    text-decoration: underline;
  }
`
